// extracted by mini-css-extract-plugin
export default {"teamTableContainer":"TeamList_teamTableContainer__kP8Uy","teamTable":"TeamList_teamTable__faTqq","noGames":"TeamList_noGames__1Nbv0"};